// extracted by mini-css-extract-plugin
export default {"header":"Header_header__PKnLe","balance":"Header_balance__ej-8k","balanceHeading":"Header_balanceHeading__KYmA7","balanceAmount":"Header_balanceAmount__azeSF"};